import Icon from '@/shared/components/Icon/Icon';
import { IonInputCustomEvent } from '@ionic/core';
import { InputChangeEventDetail, IonInput, IonNote } from '@ionic/react';
import React, { ComponentProps } from 'react';
import { FieldError } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';
import styles from './LabelOutInput.module.css';

type Props = {
  label: string;
  error?: FieldError;
  helperNotes?: string;
  isDirty?: boolean;
} & ComponentProps<typeof IonInput>;

// ref needs to be added to avoid console warnings see here:
// https://github.com/react-hook-form/react-hook-form/discussions/7864
const LabelOutInput: React.FC<Props> = React.forwardRef((props, ref) => {
  const { color, error, helperNotes, isDirty, label, name, onIonChange } = props;
  const { t } = useTranslation();
  const errorMsg = error?.message && t(error?.message);

  const onChange = (e: IonInputCustomEvent<InputChangeEventDetail>): void => {
    if (onIonChange) {
      onIonChange(e);
    }
  };

  return (
    <div className={styles.inputWrapper}>
      <IonInput
        {...props}
        className={`${styles.input} ${label ? '' : styles.hideLabel} ${error ? 'ion-invalid' : ''} ${
          isDirty ? 'ion-touched' : ''
        }`}
        color={color}
        data-testid={name}
        errorText={errorMsg}
        fill="outline"
        label={label}
        labelPlacement="floating"
        mode="md"
        ref={ref}
        onIonChange={(e) => onChange(e)}
      />
      {error && <Icon src={`assets/icons/information-circle-outline.svg`} color="danger" size="xmedium" />}
      {helperNotes && (
        <IonNote color={color}>
          <Trans components={{ span: <span /> }}>{helperNotes}</Trans>
        </IonNote>
      )}
    </div>
  );
});

export default LabelOutInput;
